import styled from 'styled-components';
import TextField from '@material-ui/core/TextField';

const CutstomTextField = styled(TextField)`
    background-color: white;
    margin: 1rem 0;
`;

export { CutstomTextField };